import type React from "react";

import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { CallFailedIcon } from "assets/videocall";
import { BaseButton } from "shared/atoms/BaseButton/BaseButton";
import { MUIUnifiedModal } from "shared/atoms/MUIUnifiedModal";

interface Props {
  readonly onMessage: () => void;
  readonly onClose: () => void;
  readonly name: string;
  readonly open: boolean;
}

export const DisconnectModal: React.FC<Props> = ({ onMessage, onClose, name, open }) => {
  const { t } = useTranslation();

  if (!open) {
    return null;
  }

  return (
    <MUIUnifiedModal open={open} onClose={onClose} showCloseButton={false} width="500px">
      <ModalBackground>
        <IconContainer>
          <IconFailedCall />
        </IconContainer>
        <Stack alignItems="center" textAlign="center" my={6} spacing={2}>
          <Typography>{t("drop_in_calls.modal.cancel_header")}</Typography>
          <Typography>{t("drop_in_calls.modal.cancel_body", { name })}</Typography>
        </Stack>

        <Stack alignItems="center" mb={1} spacing={1}>
          <BaseButton
            data-testid="call-again-button"
            onClick={onMessage}
            text={t("drop_in_calls.modal.message_patient")}
          />
          <BaseButton variant="text" data-testid="exit-call-button" onClick={onClose} text={t("buttons.exit")} />
        </Stack>
      </ModalBackground>
    </MUIUnifiedModal>
  );
};

const IconContainer = styled.div`
  margin: 0 auto;
  position: relative;
  top: 33px;
`;

const IconFailedCall = styled(CallFailedIcon)`
  width: 44px;
  height: 44px;
`;

const ModalBackground = styled.div`
  max-width: 500px;
  background: linear-gradient(to bottom, ${props => props.theme.colors.pastels.red} 64px, #fff 64px);
  padding: ${props => props.theme.spacing.S_10} ${props => props.theme.spacing.S_20}
    ${props => props.theme.spacing.S_10} ${props => props.theme.spacing.S_20};
  display: flex;
  flex-direction: column;
  align-items: center;
`;
